import axios from "axios";
import Swal from "sweetalert2";
const URL = "https://payroll.erdenetmc.mn/";

export function API() {
  const headers = {
    "Content-Type": "application/json,",
  };
  const token =
    typeof window !== "undefined" ? localStorage.getItem("token") : null;
  if (token != null) {
    Object.assign(headers, {
      Authorization: token,
    });
  }
  const api = axios.create({
    baseURL: URL,
    timeout: 200000,
    headers,
  });

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error === undefined || error.response === undefined) {
        Swal.fire({
          title: "Сервистэй холбогдсонгүй.",
          icon: "error",
          // timer: 3000,
        });
      } else {
        if (error.response.status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("menuID");
          localStorage.removeItem("menuName");
          window.location.replace("/");
        }
      }
      throw error;
    }
  );
  return api;
}

export async function logOut() {
  const response = await API().post("/api/user/logout");
  return response;
}

export async function getList() {
  const response = await API().get("/api/list");
  return response.data;
}

export async function getDetail(year, month) {
  const response = await API().get(
    "/api/detail/year/" + year + "/month/" + month
  );
  return response.data;
}
